import {
  CanActivateChildFn,
  CanActivateFn,
  RedirectCommand,
  Router,
} from '@angular/router';
import { DashboardGlobalConfigType, ToastService } from '@ckmk/angular';
import { inject } from '@angular/core';
import { PostCategoryService } from '@app/src/app/modules/post/service/post.category.service';

export const PostCategoryGuard =
  (config?: DashboardGlobalConfigType): CanActivateFn | CanActivateChildFn =>
  async (route, state) => {
    const service = inject(PostCategoryService);
    const toast = inject(ToastService);
    const router = inject(Router);
    const dashboardPath = config ? inject(config.tokens.pathBuilder) : null;

    return service
      .isExists(route, config)
      .then((value) => {
        if (!value) {
          const path = dashboardPath
            ? dashboardPath('/posts/categories/list')
            : '/blog';

          if (config) {
            toast.warning({
              text: 'Category not found',
              domain: 'warnings',
            });
          }

          return new RedirectCommand(router.createUrlTree([path]), {
            replaceUrl: true,
          });
        }

        return true;
      })
      .catch(() => {
        const path = dashboardPath
          ? dashboardPath('/posts/categories/list')
          : '/blog';

        if (config) {
          toast.warning({
            text: 'Category not found',
            domain: 'warnings',
          });
        }

        return new RedirectCommand(router.createUrlTree([path]), {
          replaceUrl: true,
        });
      });
  };
